import { faTrash } from '@fortawesome/pro-light-svg-icons/faTrash'
import { faFile } from '@fortawesome/pro-light-svg-icons/faFile'
import Button from '@hotmart/space-lib/dist/components/button'

import i18n from 'src/i18n'
import Icon from '../Icon'
import { DocumentPreviewProps } from './types'
import { DocumentPreviewContainer, ImageDocumentPreview, TextFileName } from './styles'

const DocumentPreview = ({ mediaInfo, removeMedia }: DocumentPreviewProps) => {
  return (
    <DocumentPreviewContainer className="_rounded-lg _d-flex _ml-3" data-test="document-preview">
      <div>
        <ImageDocumentPreview className="_bg-gray-200" />
      </div>

      <div className="_d-flex _justify-content-between _align-items-center _w-full _px-3">
        <div className="_d-flex">
          <div className="_d-flex _justify-content-center _align-items-center _mr-3">
            <Icon icon={faFile} size="lg" />
          </div>
          <div className="_d-flex _flex-column" data-test="info-media">
            <TextFileName className="_text-1 _text-gray-900 _font-weight-bold">
              {mediaInfo?.name}
            </TextFileName>
            <span className="_text-1 _text-gray-500">
              {mediaInfo!.size} MB - {mediaInfo?.type}
            </span>
          </div>
        </div>

        <Button type="button" variation="tertiary" onClick={removeMedia}>
          <span className="_sr-only">{i18n.t('comments.button_delete')}</span>
          <Icon icon={faTrash} />
        </Button>
      </div>
    </DocumentPreviewContainer>
  )
}

export default DocumentPreview
